import * as _ from "lodash";
import { Not_Available, Trigger_Filter_Prefix, Custom_Where } from "../../utils/FormatConstants.js";
import * as CollectionUtils from "@ane/core/lib/utils/CollectionUtils";
function filterValues(filters, predicate, valueGenerator) {
  var matched = CollectionUtils.mapIfDefined(filters, (x) => {
    return predicate(x) ? x : void 0;
  });
  if (valueGenerator) {
    if (matched.length === 0) {
      return Not_Available;
    }
    return valueGenerator(matched);
  } else {
    return matched;
  }
}
function isTriggerFilter(filter) {
  return filter.Operator.indexOf(Trigger_Filter_Prefix) === 0 && filter.Operator !== Custom_Where;
}
function filterValueGenerator(matched) {
  return CollectionUtils.mapIfDefined(matched, (x) => {
    return x ? x.Values[0] : void 0;
  }).join(", ");
}
function filterDimensionGenerator(matched) {
  return CollectionUtils.mapIfDefined(matched, (x) => {
    return x ? x.Dimension : void 0;
  }).join(", ");
}
function filterValuesGenerator(matched) {
  return matched[0].Values.join(", ");
}
function pathNameToShortName(pathName) {
  var arr = pathName.split(/[\\/]+/);
  return arr[arr.length - 1];
}
function fileNameGenerator(matched) {
  return _.map(matched, (x) => pathNameToShortName(x.FilePath)).join(", ");
}
function hasSideStream(filter) {
  return filter.TriggerFilterSideStreamInfo !== null && filter.TriggerFilterSideStreamInfo !== void 0;
}
export {
  fileNameGenerator,
  filterDimensionGenerator,
  filterValueGenerator,
  filterValues,
  filterValuesGenerator,
  hasSideStream,
  isTriggerFilter,
  pathNameToShortName
};
//# sourceMappingURL=AnalysisFilterUtils.js.map
